// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/" + {"35":"async.photoswipe","257":"async.swiper"}[chunkId] + ".min.js";
};